"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toReadableTimings = exports.pad = void 0;
function pad(num, size) {
    let number = num.toString();
    while (number.length < size)
        number = '0' + number;
    return number;
}
exports.pad = pad;
const toReadableTimings = (timings) => {
    return {
        from: `${pad(timings.from.hour, 2)}:${pad(timings.from.minute, 2)}`,
        to: `${pad(timings.to.hour, 2)}:${pad(timings.to.minute, 2)}`,
        weekdays: timings.weekdays
    };
};
exports.toReadableTimings = toReadableTimings;
